export default {
  /* eslint-disable */
  SAVE_RANK_DATA({ commit }, data = {}) {
    // commit()
  }
};
